import { useState } from "react";
import { supabase } from "@/index";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageHeading } from "./ui/page-heading";
import { PageContent } from "./ui/page-content";
import { ErrorDisplay } from "./ui/error";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const navigate = useNavigate();

  async function handleResetPassword() {
    setIsLoading(true);
    setErrorMessage(null);
    setSuccessMessage(null);

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });

      if (error) {
        setErrorMessage(error.message);
      } else {
        setSuccessMessage(
          "Password reset instructions have been sent to your email"
        );
      }
    } catch (error: any) {
      setErrorMessage(error.message);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <PageHeading>
        <div className="text-center">Reset password</div>
      </PageHeading>
      <PageContent>
        <div className="max-w-md mx-auto">
          <div className="space-y-2">
            <label className="text-sm font-medium">Email</label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
            />
          </div>

          {errorMessage && <ErrorDisplay message={errorMessage} className="mt-2" />}
          {successMessage && (
            <div className="mt-2 text-sm text-green-600">{successMessage}</div>
          )}

          <div className="space-y-2 mt-4">
            <Button
              onClick={handleResetPassword}
              isLoading={isLoading}
              disabled={!email}
              className="w-full"
            >
              Send reset instructions
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate("/")}
              className="w-full"
            >
              Back to login
            </Button>
          </div>
        </div>
      </PageContent>
    </>
  );
}

export default ForgotPassword;
